import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ProductCategoryCreateComponent } from './create';
import { ProductCategoryDetailComponent } from './detail';
import { ProductCategoryEditComponent } from './edit';
import { ProductCategorySummaryComponent } from './summary';

const routes: Routes = [
  { path: '', redirectTo: 'summary', pathMatch: 'full' },
  {
    path: '',
    data: {
      title: 'Product Category'
    },
    children: [
      {
        path: 'add',
        component: ProductCategoryCreateComponent,
        data: { title: 'Add' }
      },
      {
        path: 'detail/:id',
        component: ProductCategoryDetailComponent,
        data: { title: 'Details' }
      },
      {
        path: 'edit/:id',
        component: ProductCategoryEditComponent,
        data: { title: 'Edit' }
      },
      {
        path: 'summary',
        component: ProductCategorySummaryComponent,
        data: { title: 'Summary' }
      }
    ]
  }
];

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ]
})
export class ProductCategoryRoutingModule {}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/product-category/product-category-routing.module.ts